module.exports = __webpack_public_path__ + "static/img/Valentine'sDay-AD.74de23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Valentine'sDay-AD.png
// module id = BbPR
// module chunks = 1